import {
  ADD_PRODUCT_FAIL,
  ADD_PRODUCT_REQUEST,
  ADD_PRODUCT_SUCCESS,
  LIST_SKU_PRODUCT_FAIL,
  LIST_SKU_PRODUCT_REQUEST,
  LIST_SKU_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  VIEW_PRODUCT_FAIL,
  VIEW_PRODUCT_REQUEST,
  VIEW_PRODUCT_SUCCESS,
} from "./actionType";

export const productViewReducer = (state = {}, action) => {
  switch (action.type) {
    case VIEW_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VIEW_PRODUCT_SUCCESS:
      return {
        loading: false,
        product: action.payload,
        success: true,
        isError: false,
      };
    case VIEW_PRODUCT_FAIL:
      return {
        loading: false,
        product: {},
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const productAddReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_PRODUCT_SUCCESS:
      return {
        loading: false,
        product: action.payload,
        success: true,
        isError: false,
      };
    case ADD_PRODUCT_FAIL:
      return {
        loading: false,
        product: {},
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const productUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PRODUCT_SUCCESS:
      return {
        loading: false,
        product: action.payload,
        success: true,
        isError: false,
      };
    case UPDATE_PRODUCT_FAIL:
      return {
        loading: false,
        product: {},
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const skuProductListReducer = (state = [], action) => {
  switch (action.type) {
    case LIST_SKU_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LIST_SKU_PRODUCT_SUCCESS:
      return {
        loading: false,
        sku_products: action.payload,
        success: true,
        isError: false,
      };
    case LIST_SKU_PRODUCT_FAIL:
      return {
        loading: false,
        sku_products: [],
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};
